export default "__VITE_ASSET__WZUSIdM7__"